require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-my-5-tricks-for-relieving-abdominal-bloating.json") })
        }
      }, "path---blog-my-5-tricks-for-relieving-abdominal-bloating");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-my-5-tricks-for-relieving-abdominal-bloating!./.cache/json/blog-my-5-tricks-for-relieving-abdominal-bloating.json
// module id = 301
// module chunks = 231608221292675